import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// Regask UI type system (see modules/theme/regaskThemes.ts): Inter for UI/
// display, Geist Mono for numeric + machine data (counts, metrics, env
// labels, timestamps). Inter ships per-weight files — load only the weights
// the type scale uses (regular/medium/semibold/bold).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource-variable/geist-mono';
// Pixel/bitmap display face — used only for the Regask sidebar wordmark.
import '@fontsource/silkscreen/400.css';
import '@fontsource/silkscreen/700.css';
// Tailwind utilities for the Regask UI system (components/ui). Compiled from
// src/tailwind.css by the standalone Tailwind CLI (yarn tailwind:*) because the
// Backstage webpack build runs no postcss-loader. Theme + utilities layers
// only — no Preflight — so it coexists with the existing Material UI surface.
import './tailwind.generated.css';
import { applyPalette, getStoredPalette } from './modules/theme/palette';

// Apply the saved palette theme before first paint to avoid a flash of the
// default scheme.
applyPalette(getStoredPalette());

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
